<template>
  <div class="app-container">
    <div style="position: absolute;top: 70px;left: 650px;" v-if="active == 'ownerRentRecord'">
      <el-alert title="注：添加出租记录后自动生成收租记录，以首次收租日期为及准，按开始至结束日期间隔月数及支付类型生成！" type="success" show-icon></el-alert>
    </div>
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <el-tabs v-model="active" @tab-click="tabClick" v-if="showTabs">
          <el-tab-pane label="交租记录" name="ownerCollectRecord">
            <owner-collect-record ref="ownerCollectRecord" :house-id="houseId" :houses="houses" :owner-rent-record-id="ownerRentRecordId"></owner-collect-record>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>

import OwnerRentRecord from "@/components/OwnerRentRecord";
import OwnerCollectRecord from "@/components/OwnerCollectRecord";
import {getList as getHouses} from "@/api/house";
import {getList as getOwnerRentRecords} from "@/api/ownerRentRecord";

export default {
  components: {
    OwnerRentRecord,
    OwnerCollectRecord
  },
  data() {
    return {
      active: 'ownerCollectRecord',
      houseId: 0,
      ownerRentRecordId: 0,
      nowContractId: 0,
      houses: [],
      showTabs: false
    }
  },
  mounted() {
    this.houseId = parseInt(this.$route.query.houseId)
    this.ownerRentRecordId = parseInt(this.$route.query.ownerRentRecordId)
    if (this.$route.query.nowContractId) {
      this.nowContractId = parseInt(this.$route.query.nowContractId)
    }
    this.getHouses()
  },
  methods: {
    getHouses() {
      getHouses().then(response => {
        if (response.code == 200) {
          // 查询成功
          this.houses = response.data
          this.showTabs = true
        }
      })
    },
    tabClick() {
      const tab = this.active
      if (tab == 'ownerRentRecord') {
        this.$refs['ownerRentRecord'].search(true)
      } else if (tab == 'ownerCollectRecord') {
        this.$refs['ownerCollectRecord'].search(true)
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/back/houseOwnerDetail.vue